module.exports = __webpack_public_path__ + "static/media/sushantu.3d355678.jpeg";